var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSortUpTodo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_45820_8216",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "url(#pattern0_45820_8216)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_45820_8216)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_45820_8216)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.460938,
    width: 18,
    height: 18,
    fill: "#605BFF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_45820_8216",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_45820_8216",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_45820_8216",
    x: -4,
    y: 0.460938,
    width: 26,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_45820_8216"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_45820_8216",
    result: "shape"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_45820_8216",
    width: 64,
    height: 64,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAAHYAAAB2AH6XKZyAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAixJREFUeJztmTFLHEEUx3+KILFWIphYiBDBdBGstBYxoF/Awi8gBxFttbYwIpaCpdaCfoA0SRMUvVNrEUS75ARBT4udRY+73X27Ozuj5/vB447Z2fn/37u92ZldUBRFURRFUd4nbb4N5KALmDPft4Bbj16cM0SQ8KOJW+CLV0cO6QGueE4+jGug16MvJ/QARzQmH0aZFi5CUvItXQRp8oUUoR84oH7SyRIPQAWYSqmfNnnrRTjIIB4X/4GPQu2syYdxZMbIxb8cBqJiQqCbN3lrV0LFUtIvYzhBsws4jDn/XNgWxqEZMxNTQNVi8hsCzaWY89eA3Sbtu+ZY1HmLzYQ6BGb2gAFghBxVJJgEz4ATQd/BiPafQAnYiTheMp/zKcZ8lczQ/JcP9y5RVwCmT7MrYdqRd2uUgAsTJeo3bnEFwPRdAC5N/HDg1ylJBRDTbtHUm0QL4NuAb959ASTrgHaCR09jwIcCvdQIVnPrwE2BOqlZxf5SOC4qQGeCJ6d3gdksA+dgCBh1JSYpwGPhLjxqSgqwXbiLeirAH1dikklwCTgFxsm3GUqiRrBZWgfuBH0lbS3LCo2T4LJXR47ppv5BTdm0peYtvxrr5Plu8Zvkv42iKEoD0kmwF/hGseuAJB4INkvHroW/Y/exeN7YLDbdRk4tGbcZX20lJ9kL9NkSs8gnWwNJCvDLlpglqsBfl4KfgX38zwP3BG+VJotNV1EURVEURVEURVGUVucJa/+4SpZ/2BgAAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSortUpTodo);
export default __webpack_public_path__ + "static/media/icon-sort-up-todo.01b6305b9781c68b3935378106ab7362.svg";
export { ForwardRef as ReactComponent };